module.exports = __webpack_public_path__ + "img/colored-skiped-vertical-bar-icon-21022022.1eba00a8.svg";